import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { Button } from "@curves/ui-base";
import { EmployeeSelect } from "@icoach/components/";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import useCyclePurchaseApi from "@apis/useCyclePurchaseApi";

// 變更循環訂單建單擔當彈窗
const CyclePurchaseCoachChangeDialog = ({ className, open, sourceData, onClose, refresh }) => {
	const { memberID, cycleOrderID } = sourceData || {};
	const { getCyclePurchaseOptionsApi, postMemberCycleOrderChangeEmployeeApi } = useCyclePurchaseApi();
	const [resource, setResource] = useState({});

	const employeeRef = useRef(null);

	// 取得當店教練下拉選單
	const doCyclePurchaseOptionsApi = async () => {
		const res = await getCyclePurchaseOptionsApi();
		if (res) setResource(res);
	};

	// 送出擔當變更
	const doChangeEmployeeApi = async employeeID => {
		const res = await postMemberCycleOrderChangeEmployeeApi(memberID, { cycleOrderID, employeeID });
		if (res) {
			refresh && refresh();
			onClose();
		}
	};

	const handleSubmit = () => {
		const isError = employeeRef.current && employeeRef.current.isError && employeeRef.current.isError();
		if (isError) return;
		const employeeID = employeeRef.current && employeeRef.current.getResult && employeeRef.current.getResult();
		doChangeEmployeeApi(employeeID);
	};

	useEffect(
		() => {
			if (open) doCyclePurchaseOptionsApi();
		},
		// eslint-disable-next-line
		[open],
	);

	return (
		<Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-40rem" }} open={open} fullWidth>
			<GradientColorHeader onClose={onClose}>擔當變更</GradientColorHeader>
			<DialogContent>
				<Grid spacing={3} container>
					<Grid xs={12} item>
						<EmployeeSelect label="建單擔當" ref={employeeRef} options={resource?.coachOptions || []} fullWidth required />
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button variant="contained" onClick={handleSubmit}>
					確認送出
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default CyclePurchaseCoachChangeDialog;
